import { Button, Card, CardActions, CardHeader, Stack } from "@bvhi/ui-base";
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useRoutePermissionChecker } from "../hooks/use-route-permission-checker";

interface Props {
  Component: () => ReactElement;
  fallbackComponent?: () => ReactElement;
}

export const withPermissionCheck =
  ({ Component, fallbackComponent: FallbackComponent }: Props) =>
  () => {
    const WrappedComponent = () => {
      const { history } = useRouter();
      const { t } = useTranslation(["common"]);
      const navigate = useNavigate();
      const routeEnabled = useRoutePermissionChecker();
      if (!routeEnabled && FallbackComponent) return <FallbackComponent />;
      if (!routeEnabled && !FallbackComponent)
        return (
          <Stack pt={2} spacing={2}>
            <Card>
              <CardHeader subheader={t("common:card.no.access.sub.title")} title={t("common:card.no.access.title")} />

              <CardActions>
                <Button onClick={() => history.go(-1)} startIcon={<ArrowLeftIcon />}>
                  {t("common:card.no.access.action.back")}
                </Button>
                <Button endIcon={<ArrowRightIcon />} onClick={() => void navigate({ to: "/app/dashboard" })}>
                  {t("common:card.no.access.action.to.dashboard")}
                </Button>
              </CardActions>
            </Card>
          </Stack>
        );
      return <Component />;
    };

    return WrappedComponent();
  };
